module.exports = __webpack_public_path__ + "img/fb.9be12e8.png";